import React                     from 'react'
import loadable                  from '@loadable/component';

/* Components */
const Register      = loadable(() => import('../Components/Register'));
const Splash        = loadable(() => import('../Components/Splash'));
const Login         = loadable(() => import('../Components/Login'));
const Onboarding    = loadable(() => import('../Components/Onboarding'));

const AppRoutes = [
    {
        path:    "/",
        element: <Splash />,
        type:    "public"
    },
    {
        path:    "/login",
        element: <Login />,
        type:    "public"
    },
    {
        path:    "/proceso-registro/:typeView",
        element: <Onboarding />,
        type:    "public"
    },
    {
        path:    "/onboarding/:view/:keyAct/:primaryKey/:tarjet",
        element: <Register />,
        type:    "public"
    },
];
export default AppRoutes;